export default {
  COPA_SARAU_DETAIL: 'COPA_SARAU_DETAIL',
  COPA_SARAU_LOAD: 'COPA_SARAU_LOAD',
  COPA_SARAU_BUTTON_LOAD: 'COPA_SARAU_BUTTON_LOAD',
};
